import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../redux/features/modalSlice";
import Swal from "sweetalert2";

function ToggleStatusModal({
  title,
  id,
  currentStatus,
  statusFunction,
  onSuccess,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const newStatus =
    currentStatus === "Active" ? "Inactive" : "Active";

  const handleSubmit = async () => {
    try {
      setLoading(true);
 const payload = {
  id,
  status: currentStatus === "Active" ? "0" : "1",
};
      const res = await statusFunction(payload);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: res?.message || "Status Updated Successfully",
        timer: 2000,
        showConfirmButton: false,
      });

      if (onSuccess) {
        onSuccess();
      }

      dispatch(closeModal());
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          "Status Update Failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="custom-modal-body">

        {/* <h4 className="mb-4 text-center">
          {title}
        </h4> */}

        <div className="text-center">

          <h5>
            Current Status :
            <span
              className={
                currentStatus === "Active"
                  ? "text-success ms-2"
                  : "text-danger ms-2"
              }
            >
              {currentStatus}
            </span>
          </h5>

          <p className="mt-3">
            Are you sure you want to change status to
            <strong> {newStatus}</strong> ?
          </p>

        </div>

      </div>

      <div className="modal-btn-group justify-content-center">

        <button
          className="cancel-btn"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="save-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Updating..." : "Change Status"}
        </button>

      </div>
    </>
  );
}

export default ToggleStatusModal;